<template>
    <div class="timepicker-list gap-4 p-0 pl-4 pr-4 bg-white">
        <div class="flex justify-between w-full mt-4">
            <div>
                <span
                    class="list--header flex h-10 flex-col justify-center self-stretch text-text-default font-Open font-bold"
                    >{{ props.title }}</span
                >
            </div>
            <div class="ml-auto cursor-pointer">
                <span class="what-to-expect--info text-highlight">
                    <div
                        class="justify-start items-center flex"
                        @click="toggleTimeFormat">
                        <div
                            :class="twelveHourClass"
                            class="px-2 py-1 border-rose-600 border border-solid rounded-tl rounded-bl justify-center items-center flex">
                            <div
                                class="text-center text-xs font-bold font-['SF Pro Text'] leading-tight">
                                12h
                            </div>
                        </div>
                        <div
                            :class="twentyFourHourClass"
                            class="px-2 py-1 border-rose-600 border border-solid rounded-tr rounded-br justify-center items-center flex">
                            <div
                                class="text-center text-xs font-bold font-['SF Pro Text'] leading-tight">
                                24h
                            </div>
                        </div>
                    </div>
                </span>
            </div>
        </div>
        <ul
            class="flex flex-wrap mb-4 grid grid-cols-2 md:gap-6 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
            <li
                v-for="(item, key, index) in dynamicTimes"
                :key="index"
                :class="['cursor-pointer w-42 item']"
                @click="selectItem(item)">
                <div
                    :class="[
                        {
                            ['selected rounded border border-solid border-[#5856d6] font-bold bg-[#f7f7fd] shadow-sm']:
                                currentlySelected === item.start,
                        },
                        'card p-8 flex flex-col items-center justify-center self-stretch py-2 px-4 rounded border border-solid',
                    ]">
                    <div class="text-m">
                        {{ item.start_display }}
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { useBookingStore } from '@/stores/booking';
    import { useStateStore } from '~/stores/state';
    import { useAvailabilityStore } from '@/stores/booking-availability';
    import { convertTo12Hour } from '@/helpers/dateFormats';

    const { state: applicationState, toggleTimeFormat } = useStateStore();
    const { state: availabilityState } = useAvailabilityStore();
    const { state: bookingState, updateBookingState } = useBookingStore();

    const props = defineProps({
        title: String,
        selectedStoreOptionA: String,
        selectedStoreOptionB: String,
    });
    const currentlySelected = ref(null);

    const twelveHourClass = computed(() => ({
        'bg-rose-600 text-white': !applicationState.is24HourFormat,
        'text-rose-600': applicationState.is24HourFormat,
    }));

    const twentyFourHourClass = computed(() => ({
        'bg-rose-600 text-white': applicationState.is24HourFormat,
        'text-rose-600': !applicationState.is24HourFormat,
    }));

    // Computed Property for Transformed Time
    const dynamicTimes = computed(() => {
        return availabilityState[bookingState.selected_date].map((timeSlot) => {
            return {
                ...timeSlot,
                start_display: applicationState.is24HourFormat
                    ? timeSlot.start
                    : convertTo12Hour(timeSlot.start),
                end_display: applicationState.is24HourFormat
                    ? timeSlot.end
                    : convertTo12Hour(timeSlot.end),
            };
        });
    });

    const selectItem = (item) => {
        // Convert start and end time to hh:mm format

        updateBookingState({
            start_time: item.start,
            end_time: item.end,
        });
        currentlySelected.value = item.start;
    };
</script>
